export default "__VITE_ASSET__C$hnTxdM__"